<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconWarning_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M13.417 19.3a1.7 1.7 0 0 1-1.7 1.7H11.7a1.7 1.7 0 1 1 0-3.4h.017a1.7 1.7 0 0 1 1.7 1.7Zm-1.7-5.1a1.7 1.7 0 0 1-1.7-1.7V4.7a1.7 1.7 0 1 1 3.4 0v7.8a1.7 1.7 0 0 1-1.7 1.7Z"
        clip-rule="evenodd"
    />
</svg>
